__turbopack_context__.v({
  "asideIcon": "QrMDlq_asideIcon",
  "asideItem": "QrMDlq_asideItem",
  "asideItemText": "QrMDlq_asideItemText",
  "asideItemTitle": "QrMDlq_asideItemTitle",
  "asideList": "QrMDlq_asideList",
  "asideTitle": "QrMDlq_asideTitle",
  "brand": "QrMDlq_brand",
  "brandMark": "QrMDlq_brandMark",
  "ctaRow": "QrMDlq_ctaRow",
  "featureCard": "QrMDlq_featureCard",
  "featureIcon": "QrMDlq_featureIcon",
  "featureText": "QrMDlq_featureText",
  "featureTitle": "QrMDlq_featureTitle",
  "features": "QrMDlq_features",
  "featuresSection": "QrMDlq_featuresSection",
  "footer": "QrMDlq_footer",
  "hero": "QrMDlq_hero",
  "heroAside": "QrMDlq_heroAside",
  "heroCopy": "QrMDlq_heroCopy",
  "kicker": "QrMDlq_kicker",
  "lede": "QrMDlq_lede",
  "main": "QrMDlq_main",
  "metaNote": "QrMDlq_metaNote",
  "page": "QrMDlq_page",
  "primaryCta": "QrMDlq_primaryCta",
  "secondaryCta": "QrMDlq_secondaryCta",
  "sectionHeading": "QrMDlq_sectionHeading",
  "signInLink": "QrMDlq_signInLink",
  "title": "QrMDlq_title",
  "topActions": "QrMDlq_topActions",
  "topBar": "QrMDlq_topBar",
});
